import React, { useEffect, useState } from "react";
import MyModal from "./CustomModal/Modal";
import { Select, Button } from "antd";
import {
  DeleteFilled,
  DeleteOutlined,
  LoadingOutlined,
  LockOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getUserInChannelByChannelIdThunk, setAddUserInChannel, setNewChannelList, setSelectedUserOrChannel } from "../slices/userSlice";
import GradientButton from "./Button/GradientButton";
import ButtonGroupPortfolio from "./Profile/ButtonGroup";
import CustomTooltip from "./CustomTooltip/CustomTooltip";
import LoadingCom from "./LoadingCom";
import { deleteByPkAndSk, removeUserFromChannel } from "../services/awsServices";
import toastMessage from "../utils/toastMessage";

const tabs = [
  { id: 1, Icon: null, name: "Channel Details" },
  { id: 2, Icon: null, name: "Add People" },
];

const ChatAddPeopleModal = ({ isModalOpen, setIsModalOpen, title }) => {
  const dispatch = useDispatch();
  // const userId = localStorage.getItem("username");
  const [selectedtab, setSelectedTab] = useState(tabs[0].id);
  const [selectedUserNames, setSelectedUserNames] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteChannelLoader, setDeleteChannelLoader] = useState(false);
  const userList = useSelector((state) => state.user.userList) || [];
  const user = useSelector((state) => state.user.userAttributes);
  const selectedChannel = useSelector(
    (state) => state.user.selectedUserOrChannel
  );
  const usersInChannel = useSelector((state) => state.user.usersInChannel) || {};
  const userChannelList = useSelector((state) => state.user.userChannelList) || [];

  const alreadyAddedUser = Object.keys(usersInChannel[selectedChannel?.SK] || {});

  const alreadyUserFilter = userList.filter((items) => alreadyAddedUser.includes(items.PK.S));

  const addUserInChannel = useSelector((state) => state.user.addUserInChannel);
  const websocket = useSelector((state) => state.socket.websocket);
  const filterUserList = userList?.filter(
    (user) => !user.Email?.S.includes(user?.sub)
  );

  useEffect(() => {
    if (!addUserInChannel?.loader && addUserInChannel?.isAdded) {
      handleCancel();
      dispatch(setAddUserInChannel({ loader: false, isAdded: false }));
    }
  }, [addUserInChannel]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    // setIsModalOpen(false);
    // console.log({selectedUserNames});
    dispatch(setAddUserInChannel({ loader: true, isAdded: false }));
    const userIds = selectedUserNames?.map((user) => user.value);
    const dataToBeSend = {
      RequestType: "add-users-in-channel",
      userIds,
      channelId: selectedChannel?.SK,
      addedBy: user?.sub?.includes("User#") ? user?.sub : `User#${user?.sub}`,
      channelName: title,
    };
    console.log(dataToBeSend, " =dataToBeSend");

    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(
        JSON.stringify({ action: "sendmessage", ...dataToBeSend })
      );
      setSelectedUserNames([])
    } else {
      console.error("WebSocket is not connected.");
    }
  };

  // const selectOptions = filterUserList?.map((user) => ({
  //   value: user.PK.S,
  //   label: user.Name.S,
  // }));

  const removeUserFun = (channelId, userId) => {
    dispatch(setAddUserInChannel({  loader: true, isAdded: false, }));
    removeUserFromChannel(channelId, userId)
      .then((res) => {
        console.log(res.data, " =channel:remove");
        toastMessage(res.data.message, "success");
        dispatch(getUserInChannelByChannelIdThunk(channelId)).unwrap();
      })
      .catch((err) => {
        toastMessage(err.response.data.message, "error");
      }).finally(()=>{
        dispatch(setAddUserInChannel({  loader: false, isAdded: false, }));
      });
  };

  const handleDeleteChannel = async () => {
    console.log(selectedChannel.channelDetails, " =selectedChannel:deleteChannel");
    setDeleteChannelLoader(true);
    const promises = alreadyAddedUser?.map(userId => {
      return deleteByPkAndSk({ sk: selectedChannel?.SK, pk: userId });
    })
    const resolved = await Promise.all(promises);

    console.log(resolved, "channelDeleteeeeeeee:resolved");

    const channelDelete = await deleteByPkAndSk({ pk: selectedChannel.channelDetails.PK, sk: selectedChannel.channelDetails.SK });
    console.log(channelDelete.status, "=channelDeleteeeeeeee:final");
    if(channelDelete.status === 200){
      toastMessage("Channel Successfuly Deleted", "success");
      const channels = userChannelList.filter(channel => channel.SK !== selectedChannel?.SK);
      console.log(userChannelList    , "=channelList:addPeople, ", channels);
      dispatch(setNewChannelList(channels))
      setDeleteModal(false);
      dispatch(setSelectedUserOrChannel(null));
    }
    else{
      toastMessage("Error Deleting Channel", "error");
    }
    setDeleteChannelLoader(false);
  }

  const selectOptions = [];
  for (let i = 0; i < filterUserList?.length; i++) {
    selectOptions.push({
      label: filterUserList[i].Name.S,
      value: filterUserList[i].PK.S,
    });
  }

  const handleSelectChange = (value, option) => {
    // console.log({value, option});
    setSelectedUserNames([...selectedUserNames, option]);
  };

  const handleRemoveUser = (userId) => {
    const updatedUserNames = selectedUserNames.filter(
      (user) => user.value !== userId
    );
    setSelectedUserNames(updatedUserNames);
  };

  return (
    <>
      <MyModal
        title="Are you Sure to delete this channel?"
        de
        open={deleteModal}
        onOk={()=>{}}
        onCancel={()=>setDeleteModal(false)}
        footer={[]}
      >
        <p>This Action not be reversed, If you delete this channel all messages and user have been lost.</p>
        <div className="flex items-center justify-end gap-4">
          <button onClick={()=>{setDeleteModal(false); setIsModalOpen(true)}} className="bg-gray-500 hover:bg-gray-600 text-pureWhite px-6 py-2 rounded-full">No</button>
          <GradientButton
            className="bg-sandAgainBtn border-none text-pureWhite rounded-3xl"
            onClick={handleDeleteChannel}
          >
            Yes {deleteChannelLoader && <LoadingOutlined style={{ color: 'white', }} />}
          </GradientButton>
        </div>
      </MyModal>
      <MyModal
        title={
          <div className="flex items-center gap-6">
            {selectedChannel?.channelDetails?.SK === "Private#" ? (
              <CustomTooltip title="Private Channel">
                <LockOutlined /> {title}
              </CustomTooltip>
            ) : (
              <CustomTooltip title="Public  Channel"># {title}</CustomTooltip>
            )}
            {selectedChannel.channelDetails.CreatedBy.includes(user?.sub) && 
              <div>
                <CustomTooltip title="Delete Channel">
                  <DeleteFilled onClick={()=>{setDeleteModal(true);handleCancel()}} style={{ color: 'red', cursor: 'pointer' }} />
                </CustomTooltip>
              </div>
            }
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        <ButtonGroupPortfolio
          tabs={tabs}
          selectedtab={selectedtab}
          setSelectedTab={setSelectedTab}
        />
        {selectedtab === tabs[1].id ? (
          <>
            <h1 className="font-semibold text-lg mb-5">Add People</h1>
            <Select
              showSearch
              className="w-full"
              placeholder="Select People..."
              optionFilterProp="children"
              // filterOption={(input, option) =>
              //   (option?.label ?? "").includes(input)
              // }
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={selectOptions}
              onChange={handleSelectChange}
            />
            <div className="mt-2 p-3">
              {selectedUserNames?.map((user, index) => (
                <div key={index} className="flex items-center justify-between">
                  <h1 className="mr-2">{user?.label}</h1>
                  <button
                    className="bg-signupTextBg inline-block text-transparent bg-clip-text font-semibold"
                    onClick={() => handleRemoveUser(user?.value)}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
            <div className="w-full flex justify-end">
              <GradientButton
                className="bg-sandAgainBtn border-none text-pureWhite rounded-3xl"
                icon={<UserAddOutlined />}
                onClick={handleOk}
                disabled={
                  selectedUserNames?.length === 0 || addUserInChannel?.loader
                }
              >
                Add People {addUserInChannel?.loader && <LoadingOutlined />}
              </GradientButton>
            </div>
          </>
        ) : (
          <div className="max-h-52 overflow-auto p-3">
            {alreadyUserFilter.length ? (
              alreadyUserFilter.map((items, i) => {
                return (
                  <div
                    key={i}
                    className="flex items-center justify-between space-y-2"
                  >
                    {console.log("🚀 ~ alreadyUserFilter.map ~ items:", items)}
                    <h1 className="mr-2">{items?.Name.S}</h1>
                    <button
                      disabled={addUserInChannel?.loader}
                      className={`font-semibold ${addUserInChannel?.loader ? 'text-gray-500': 'bg-signupTextBg inline-block text-transparent bg-clip-text'}`}
                      onClick={() =>
                        removeUserFun(selectedChannel?.SK, items?.PK.S)
                      }
                    >
                      Remove 
                      {/* {addUserInChannel?.loader && <LoadingOutlined style={{ color: 'orange', }} />} */}
                    </button>
                  </div>
                );
              })
            ) : (
              <LoadingCom />
            )}
          </div>
        )}
      </MyModal>
    </>
  );
};

export default ChatAddPeopleModal;
